import { render, staticRenderFns } from "./LoginRegister.vue?vue&type=template&id=f84880b4"
import script from "./LoginRegister.vue?vue&type=script&lang=ts"
export * from "./LoginRegister.vue?vue&type=script&lang=ts"
import style0 from "./LoginRegister.vue?vue&type=style&index=0&id=f84880b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports